
import Apple from "../../../assets/outline/Apple.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AppleIcon({ className, dataTestid = "AppleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Apple data-testid={dataTestid} className={classes} {...rest} />
  );
}
